

<div>
  <!--<actorvitalform></actorvitalform>-->
  <div class="row">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header wh-header card-title-schedule-bl padding-top-0px padding-bottom-0px padding-right-0px padding-left-10px">
          Vital Signs
        </div>
        <div class="card-body">
          <div class="row">
            <div class="badge Chat-box3 margin-right-10px margin-bottom-10px col-md-4" *ngFor="let l of CurrentVitalLatestFormByFormattedCodeController">
              <div>
                <a (click)="VitalDetail(l)" class="nav-link-hand table-anchor">{{l.AttributeName}}</a>

              </div>
              <div class="margin-top-10 border-top-light2">
                <label class="margin-top-10">{{l.ValueData}}</label>
                <label>{{l.UOM}}</label>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="col-md-4">
      <div class="card" *ngIf="ShowVitalDetail">
        <div class="card-header wh-header card-title-schedule-bl padding-top-0px padding-bottom-0px padding-left-10px">
          <div class="row" *ngIf="SelectedVitalDetails">
            <div class="col-md-8">
              {{SelectedVitalDetails.AttributeName}}
            </div>
            <div class="col-md-4">
              <a (click)="EditVitalShow(SelectedVitalDetails)" class="nav-link-hand education-navlink float-right" title="Edit">
                <span class="badge"><i class="fas fa-pencil-alt"></i></span>
              </a>
            </div>
          </div>

        </div>
        <div class="card-body padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px margin-left-13px">
          <div class="table-component">
            <div class="table-responsive overflow-x">
              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>
                    <th>
                      Last Updated
                    </th>
                    <th class="">
                      Value
                    </th>








                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of SelectedVitalDetailsData">
                    <td>{{l.Date | date:'dd-MMM-yyyy'}}</td>
                    <td>{{l.ValueData}} {{l.UOM}}</td>

                    <!--<td><a (click)="VitalDetail()" class="nav-link-hand table-anchor">{{l.AttributeName}}</a></td>-->
                    <!--<td>1250 mmol/L</td>
                    <td>21-Jan-2019</td>-->


                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
      <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="row" *ngIf="SelectedVitalDetails">
          <div class="card" *ngIf="EditVitalDetail">
            <div class="card-header wh-header card-title-schedule-bl padding-top-0px padding-bottom-0px padding-left-10px">
              <div class="row">
                <div class="col-md-10 padding-right-0px">
                  Modify Vital Sign
                </div>
                <div class="col-md-2 display-inherit  padding-left-0px padding-right-0px">
                  <button (click)="BackVitalDetials()" *ngIf='!isRequesting' class="btn  button-cancel  nav-link-hand margin-left-0px margin-right-12px" title="Cancel"><i class="fas fa-times"></i></button>
                  <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn button-save nav-link-hand" title="Save"><i class="fa fa-check" aria-hidden="true"></i></button>
                </div>

              </div>


            </div>
            <div class="card-body">


              <div class="col-md-6 padding-left-0px margin-left3px">
                {{SelectedVitalDetails.AttributeName}}
              </div>
              <div class="row  ">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-left margin-tg-auto padding-left-13px">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Value</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 padding-right-0px">
                      <input type="number" class="form-control" placeholder="Value" id="CurrentEditVitalRequest.ValueData" [(ngModel)]="CurrentEditVitalRequest.ValueData" name="CurrentEditVitalRequest.ValueData" pattern="^[\sa-zA-Z0-9,./_\-?]*$" #ValueData="ngModel" />
                      <small class="form-text text-danger"
                             *ngIf="(!ValueData.valid && ValueData.errors.pattern)">(special characters are not allowed)</small>
                    </div>{{SelectedVitalDetails.UOM}}
                  </div>


                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-8 text-align-left margin-tg-auto">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"> Date Of Observation</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 padding-right-0px">
                      <div class="date-form">
                        <input class="form-control" placeholder="Date"
                               name="dp" [(ngModel)]="UpdateDate" ngbDatepicker #d="ngbDatepicker" required #DateOfBirth="ngModel">
                        <!--<small class="form-text text-danger"
                        *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>
                    </div>
                  </div>


                </div>
              </div>
              <!--<div class="col-md-6 padding-left-0px padding-right-0px">
                <button (click)="BackVitalDetials()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand cancel-two margin-left-0px margin-right-5px"><i class="fas fa-times"></i></button>
                <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand"><i class="fa fa-check" aria-hidden="true"></i></button>
              </div>-->
            </div>







          </div>
        </div>
      </form>
    </div>
  </div>
</div>



